import React from "react";
import Link from "../Link";
import "./ExpandLIFButton.css";

const ExpandLIFButton = () => {

    return (
        <Link href="/lif-page">
            <div className="group-1000004555 border-1px-athens-gray-2">
                <div className="expand-lif-button">
                    <div className="expand-lif-button-5">
                        <div className="lif-text">
                            <div className="lif-text-1 nunito-bold-blue-20px">LIF</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default ExpandLIFButton;